import * as React from 'react';
import { ActionCell } from './ActionCell';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const InfoCell = ({ ...props }) => {
    const ITEM_HEIGHT = 48;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const options = [
        {
            title: 'Action',
            data: <ActionCell dataId={props?.dataItem?.id} gridFlagVal={props?.cells?.gridFlagVal} dataStatus={props?.dataItem?.status} setErrorParameterAndMessage={props?.cells?.setErrorParameterAndMessage}/>
        },

    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (

        <td className={props.className} style={props.style}>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                sx={{p:0}}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                    },
                }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} onClick={handleClose} className='customMenuItem'>
                        {option.data}
                    </MenuItem>
                ))}
            </Menu>
        </td>
    );
};